<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';

    const localize = getLocalization();
</script>

<div class="kp-line-loading-indicator"
     role="progressbar"
     aria-label="{localize(/* @kp-localization commons.LoadingInProgress */ 'commons.LoadingInProgress')}">

    <div role="presentation" class="inner-indicator"></div>
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .kp-line-loading-indicator {
        position: relative;
        width: 250px;
        max-width: 90dvw;
        height: 8px;
        border-radius: 4px;
        overflow: hidden;
        background-color: @panel-default-border;

        .inner-indicator {
            position: absolute;
            left: 0;
            top: 0;
            width: 50%;
            height: 8px;
            background-color: var(--accent-blue-new);
            border-radius: 4px;
            animation: loading 2.5s infinite ease-in-out;
        }
    }

    @keyframes loading {
        0% {
            width: 50%;
            left: -50%;
        }
        100% {
            width: 25%;
            left: 100%;
        }
    }
</style>